import { z } from "zod/v4";

export const ActionTypeList = [
  "user_input",
  "tool_approval",
  "continue",
  "complete",
] as const;
export const ActionTypeSchema = z.enum(ActionTypeList);
export type ActionType = z.infer<typeof ActionTypeSchema>;

export const UserInputTypeList = [
  "text",
  "file",
  "choice",
  "confirmation",
  "survey",
] as const;
export const UserInputTypeSchema = z.enum(UserInputTypeList);
export type UserInputType = z.infer<typeof UserInputTypeSchema>;
